import * as Connector from 'shared/connectors/reportConnector';
import { REPORT } from 'store/types';

const init = () => ({
  type: REPORT.REPORTS_FILTERS_LIST_INIT,
});

export const success = data => ({
  type: REPORT.REPORTS_FILTERS_LIST_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: REPORT.REPORTS_FILTERS_LIST_FAILURE,
});

const getReportsFiltersList = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getReportsFiltersList();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getReportsFiltersList;
